module.exports = __webpack_public_path__ + "static/investiv-about.892a840b.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/investiv-about.jpg
// module id = 916
// module chunks = 3